<div class="container-fluid container" aria-labelledby="security-question-title">
  <div class="row fun__main">
    <div class="fun__user-info">
      <div class="fun__mfa">
        <h1 class="fun__mfa__title" id="security-question-title" tabindex="0">Security Question</h1>

        <label
          class="fun__form__input-label fun__form__item"
          id="security-question-instruction"
          for="question-input"
          tabindex="0"
        >
          Select the answer for each of the following questions.
        </label>

        <form [formGroup]="questionnaireForm" class="fun__form fun__form--inverse js-form" action="" autocomplete="off">
          <fieldset role="radiogroup" aria-required="true">
            <div class="fun__form__row">
              <label
                class="fun__form__input-label fun__form__item"
                tabindex="0"
                [attr.aria-label]="questions[currentQuestionIndex]?.question"
              >
                <div class="fun__form__label-text">
                  <legend>{{ questions[currentQuestionIndex]?.question }}</legend>
                </div>
              </label>
              <div
                *ngFor="let option of questions[currentQuestionIndex]?.options; let i = index"
                class="fun__form__label-text"
                [attr.aria-label]="option.answer"
                [attr.aria-labelledby]="option.answer"
                tabindex="0"
                role="radiogroup"
              >
                <input
                  type="radio"
                  [value]="i"
                  id="option-{{ currentQuestionIndex }}-{{ i }}"
                  [attr.aria-label]="option.answer"
                  [attr.aria-labelledby]="option.answer"
                  [formControlName]="questions[currentQuestionIndex]?.key.toString()"
                  class="fun__form__input-label_radio"
                />
                <label for="answer" class="fun__form__input-label_radio" [attr.aria-label]="option.answer">
                  {{ option.answer }}
                </label>
              </div>
              <small
                *ngIf="customError"
                class="text-danger"
                role="alert"
                #errorElement
                aria-live="assertive"
                tabindex="-1"
                >{{ errorMessage }}</small
              >
            </div>

            <div class="tabs-button">
              <div class="fun__form__row tab">
                <button
                  *ngIf="currentQuestionIndex > 0"
                  type="button"
                  (click)="onBack()"
                  [disabled]="currentQuestionIndex === 0"
                  class="fun__button fun__button--arrow fun__button--secondary fun__button--small js-form-submit"
                  aria-label="Previous Question"
                >
                  Previous
                </button>
              </div>
              <div class="fun__form__row tab" *ngIf="currentQuestionIndex < questions.length - 1">
                <button
                  type="button"
                  class="fun__button fun__button--arrow fun__button--secondary fun__button--small js-form-submit"
                  (click)="onNext()"
                  aria-label="Next Question"
                >
                  Next
                </button>
              </div>
              <div class="fun__form__row tab" *ngIf="currentQuestionIndex === questions.length - 1">
                <button
                  type="button"
                  (click)="onSubmit()"
                  class="fun__button fun__button--arrow fun__button--secondary fun__button--small js-form-submit"
                  aria-label="Submit Answers"
                >
                  <span>Submit</span>
                </button>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  </div>
</div>
